import { render, staticRenderFns } from "./filesList.vue?vue&type=template&id=d2bcc8ca"
import script from "./filesList.vue?vue&type=script&lang=js"
export * from "./filesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports